import React, {Component} from 'react';

class Footer extends Component {
  render() {
    return (
      <footer className="app-footer">
        <span> &copy; 2018 <a target="_blank" href="http://srjx.resellerindia.in">School Management.</a></span>
        <span className="ml-auto">Powered by <a target="_blank" href="http://peacesoft.in">Peacesoft</a></span>
      </footer>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js